import { render, staticRenderFns } from "./TableLightWeight.vue?vue&type=template&id=2fe60d63&"
import script from "./TableLightWeight.vue?vue&type=script&lang=js&"
export * from "./TableLightWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports